import { FromSchema, ZodDate } from '@40seas/entities/common';
import { z } from 'zod';

const ChargeDateSchema = z.object({
    initiated: ZodDate,
    inTransit: ZodDate,
    completed: ZodDate,
});

export class ChargeDate extends FromSchema(ChargeDateSchema) {
    initiated: Date;
    inTransit: Date;
    completed: Date;
}
